import { resolveComponent as _resolveComponent, createVNode as _createVNode, openBlock as _openBlock, createElementBlock as _createElementBlock, createCommentVNode as _createCommentVNode, resolveDynamicComponent as _resolveDynamicComponent, mergeProps as _mergeProps, createBlock as _createBlock, createElementVNode as _createElementVNode } from "vue"

const _hoisted_1 = ["x", "y", "width", "height"]
const _hoisted_2 = {
  style: {"width":"100%","height":"100%","overflow-y":"auto"},
  class: "scrollbar-hidden"
}
const _hoisted_3 = {
  key: 0,
  style: {"position":"absolute","top":"10px","right":"10px","z-index":"10"}
}

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_BoxPopupMenu = _resolveComponent("BoxPopupMenu")!

  return (_openBlock(), _createElementBlock("foreignObject", {
    x: _ctx.box.x,
    y: _ctx.box.y,
    width: _ctx.box.width,
    height: _ctx.box.height,
    style: {"position":"relative"}
  }, [
    _createElementVNode("div", _hoisted_2, [
      (!_ctx.preview)
        ? (_openBlock(), _createElementBlock("div", _hoisted_3, [
            _createVNode(_component_BoxPopupMenu, {
              box: _ctx.box,
              hideOptions: _ctx.hideMenuOptions
            }, null, 8, ["box", "hideOptions"])
          ]))
        : _createCommentVNode("", true),
      (_openBlock(), _createBlock(_resolveDynamicComponent(_ctx.tag), _mergeProps(_ctx.props, {
        box: _ctx.box,
        container: _ctx.box,
        preview: _ctx.preview
      }), null, 16, ["box", "container", "preview"]))
    ])
  ], 8, _hoisted_1))
}